const constants = {
  USERS_FETCH_START: 'USERS_FETCH_START',
  USERS_FETCH_END: 'USERS_FETCH_END',
  USERS_CHANGE_FILTER: 'USERS_CHANGE_FILTER',
  USERS_RESET_FILTER: 'USERS_RESET_FILTER',
  COMPANIES_FETCH_START: 'COMPANIES_FETCH_START',
  COMPANIES_FETCH_END: 'COMPANIES_FETCH_END',
};

export default constants;
